import React from 'react';

import {View, Text, StyleSheet} from 'react-native';

import {useAcknowledgements} from '../../context/AcknowledgementsContext';
import {CONTENT_TYPES} from '../../constants/trustContent';

export const Notification = ({value}) => {
  if (value === 0) return null;
  return (
    <View style={styles.container}>
      <Text style={styles.notification}>{value}</Text>
    </View>
  );
};

const AcknowledgementNotification = ({data}) => {
  const {acknowledgements} = useAcknowledgements();
  const ackIds = acknowledgements.map(({ContentID}) => ContentID);
  const filteredData = data.filter(d => !ackIds.includes(d));

  if (!filteredData?.length) {
    return null;
  }

  return <Notification value={filteredData?.length} />;
};

const getNotificationForType = (type, data, screenProps) => {
  switch (type) {
    case CONTENT_TYPES.PGDS: {
      const acknowledged = data.filter(d => !d.pgdInfo.acknowledged);
      return <Notification value={acknowledged.length} />;
    }
    case CONTENT_TYPES.PMAS: {
      const acknowledged = data.filter(d => !d.pgdInfo.acknowledged);
      return <Notification value={acknowledged.length} />;
    }
    case CONTENT_TYPES.CASE_STUDIES: {
      return <></>;
    }
    case CONTENT_TYPES.PODCASTS: {
      const listenedPods = data.filter(d => {
        const currentPodcastHistory = screenProps.audioHistory?.find(
          pod => pod.audioId === d.Id,
        );
        const hasListened = Boolean(
          currentPodcastHistory?.secondsListened >= 60,
        );
        return !hasListened;
      });

      return <Notification value={listenedPods.length} />;
    }
    case CONTENT_TYPES.VIDEOS:
      return (
        <AcknowledgementNotification
          data={data.filter(d => d.SupportsAck).map(d => d.id)}
        />
      );
    case CONTENT_TYPES.PSIRF: {
      return <AcknowledgementNotification data={data.map(d => d.ID)} />;
    }
    case CONTENT_TYPES.STANDBY_CPD: {
      return <></>;
    }
    default:
      return <></>;
  }
};

const TrustNotification = ({type, data, screenProps}) => {
  return getNotificationForType(type, data, screenProps);
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#ED242B',
    height: 20,
    width: 20,
    borderRadius: 100,
    alignContent: 'center',
    justifyContent: 'center',
  },
  notification: {
    color: '#FFFFFF',
    fontSize: 12,
    textAlign: 'center',
  },
});

export default TrustNotification;
